import {getContainingComponent} from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");

const AutoFocusService = require("ceres/app/services/AutoFocusService");
import {detectPassiveEvents} from "ceres/app/helper/featureDetect";
import {getStyle} from "ceres/app/helper/dom";
import Vue from "vue";
import HeaderScroller from "ceres/app/helper/HeaderScroller";
import AOS from "aos";
import simpleParallax from "simple-parallax-js";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector) {
    headerCollapses.push(selector);
    $(document).ready(function() {
        $(selector).on("show.bs.collapse", () => {
            headerCollapses.forEach((element) => {
                if (!$(element).is(selector)) {
                    $(element).collapse("hide");
                }
            });
        });
    });
}

function CeresMain() {
    const browser = browserDetect.detect();

    if (browser) {
        if (browser.name) {
            $("html").addClass(browser.name);
        } else {
            $("html").addClass("unknown-browser");
        }
        if (browser.os) {
            $("html").addClass(
                browser.os
                    .toLowerCase()
                    .replace(/[^a-zA-Z0-9\-]/g, "-")
                    .replace("windows", "windows windows")
            );
        } else {
            $("html").addClass("unknown-os");
        }
    } else {
        $("html").addClass("unknown-detect");
    }

    // Detect Facebook integrated Browser
    if (
        typeof navigator !== "undefined" &&
        /FBA[NV]\/([0-9\.]+)/.test(navigator.userAgent)
    ) {
        document.body.classList.add("facebook");
    }

    window.onpopstate = function(event) {
        if (event.state && event.state.requireReload) {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll('[data-toggle="tooltip"]').forEach((el) => {
        $(el).tooltip();
    });

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hiding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder) {
        $(document).on("click", function(evt) {
            headerCollapses.forEach((element) => {
                if (
                    evt.target !== element &&
                    $(evt.target).parents(element).length <= 0
                ) {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function() {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function() {
        $(".main").off("click", closeNav);
    });

    const STYLES_AMAZON_PAY_LOGIN = `.amazonpay-signin-button-logo img{max-width:160px;}`;

    function modifyAmazonPayLoginButton() {
        setInterval(function() {
            const allButtons = document.querySelectorAll(
                ".amazon-login-button"
            );
            if (allButtons.length > 0) {
                allButtons.forEach(function(button) {
                    if (button && button.shadowRoot) {
                        if (
                            button.shadowRoot.querySelector(
                                "#custom-button-style"
                            )
                        )
                            return;
                        const style = document.createElement("style");
                        style.innerHTML = STYLES_AMAZON_PAY_LOGIN;
                        style.id = "custom-button-style";
                        button.shadowRoot.appendChild(style);
                    }
                });
            }
        }, 200);
    }

    modifyAmazonPayLoginButton();

    function closeNav() {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function() {
        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function() {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput) {
                searchInput.focus();
            }
        });

        window.addEventListener(
            "scroll",
            function() {
                // scroll header anpassung
                if ($(window).scrollTop() > 50) {
                    $(".header__wrapper").addClass("scrolled");
                    $("body").addClass("scrolled");
                } else {
                    $(".header__wrapper").removeClass("scrolled");
                    $("body").removeClass("scrolled");

                    if (window.innerWidth < 992) {
                        $(".header__wrapper").removeClass("search-visible");
                        $("body").removeClass("search-visible");
                    } else {
                        $(".header__wrapper").removeClass("search-visible--lg");
                        $("body").removeClass("search-visible--lg");
                        $("input.search-input:focus")
                            .blur()
                            .focus();
                    }
                }

                if (isDesktop) {
                    if ($(window).scrollTop() > offset) {
                        $(".back-to-top").fadeIn(duration);
                        $(".back-to-top-center").fadeIn(duration);
                    } else {
                        $(".back-to-top").fadeOut(duration);
                        $(".back-to-top-center").fadeOut(duration);
                    }
                }
            },
            detectPassiveEvents() ? {passive: true} : false
        );

        window.addEventListener("resize", function() {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").on("click", function(event) {
            event.preventDefault();

            $("html, body").animate({scrollTop: 0}, duration);

            return false;
        });

        $(".back-to-top-center").on("click", function(event) {
            event.preventDefault();

            $("html, body").animate({scrollTop: 0}, duration);

            return false;
        });

        $("#accountMenuList").on("click", function() {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        $(".ddown").on("keydown", function(event) {
            if (event.key === "Space" || event.keyCode === 32) {
                event.preventDefault();
                const li = this.closest("li");

                const isOpen = li.classList.toggle("hover");

                this.setAttribute("aria-expanded", isOpen);
            }
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function() {
            this.dispatchEvent(
                new CustomEvent("updateStickyContainer", {
                    bubbles: true,
                })
            );
        });

        if (
            document
                .getElementsByClassName("single-title")[0]
                ?.getElementsByTagName("span")[0].innerHTML === ""
        ) {
            document
                .getElementsByClassName("single-title")[0]
                .getElementsByTagName("p")[0]
                .classList.add("d-none");
        }

        $(document).on("click", ".card .facet-title", function() {
            let activeElement = $(this)
                .closest(".card-columns.row")
                .find(".card.open");
            let clickElement = $(this).parent();
            if (
                activeElement.hasClass("open") &&
                clickElement.hasClass("open")
            ) {
                clickElement.removeClass("open");
            } else {
                activeElement.removeClass("open");
                clickElement.toggleClass("open");
            }
        });
        $(document).on("click", ".filter-headline", function() {
            $(".findologic-filter-wrapper").toggleClass("open");
        });
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event) {
    if (event.detail.type) {
        switch (event.detail.type) {
            case "info":
                NotificationService.info(event.detail.message);
                break;
            case "log":
                NotificationService.log(event.detail.message);
                break;
            case "error":
                NotificationService.error(event.detail.message);
                break;
            case "success":
                NotificationService.success(event.detail.message);
                break;
            case "warning":
                NotificationService.warn(event.detail.message);
                break;
            default:
                console.log("no type such as:" + event.detail.type);
                break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
new HeaderScroller();

$(document).on(
    "shopbuilder.after.drop shopbuilder.after.widget_replace",
    function(event, eventData, widgetElement) {
        const parent = widgetElement[1];

        const parentComponent = getContainingComponent(parent);

        const compiled = Vue.compile(widgetElement[0].outerHTML, {
            delimiters: ["${", "}"],
        });
        const component = new Vue({
            store: window.ceresStore,
            render: compiled.render,
            staticRenderFns: compiled.staticRenderFns,
            parent: parentComponent,
        });

        component.$mount(widgetElement[0]);
        $(component.$el)
            .find("*")
            .each(function(index, elem) {
                $(elem).on("click", function(event) {
                    event.preventDefault();
                });
            });

        $(component.$el)
            .find(".owl-carousel")
            .on("resized.owl.carousel", function() {
                window.dispatchEvent(new Event("resize"));
            });
    }
);

function fixPopperZIndexes() {
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach((el) => {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex)) {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}

if (window.innerWidth >= 768) {
    document.addEventListener("click", function(evt) {
        if (
            !evt.target.closest(".fl-as-visible") &&
            !evt.target.closest(".header-search__wrapper")
        ) {
            if (!!document.querySelector(".fl-assisted-suggest")) {
                if (
                    document.querySelector(".fl-assisted-suggest").style
                        .visibility === "visible"
                ) {
                    document.querySelector(".fl-closing-btn").click();
                }
            }
        }
    });
}

window.addEventListener("load", function() {
    AOS.init();

    if (!!document.querySelector('[data-id="6035"] small')) {
        let amz = document.querySelector('[data-id="6035"] small');
        let oldString = amz.innerHTML;
        amz.innerHTML = oldString.replace(":-)", "");
    }
});

import "./jquery/lazy-images";
import "./jquery/header";
import "./jquery/swiper";
import "./jquery/od-custom";
import "./jquery/category-preview-handler";
import "./jquery/send-contact";
